import React, {useEffect, useRef} from 'react';
import {useDispatch} from 'react-redux';
import SwiperCore, {Navigation, Pagination} from 'swiper';
import {Swiper, SwiperSlide} from 'swiper/react';
import {setActiveTabs} from 'app/top-tabs-reduser';
import {useAppSelector} from "common/hook";
import {ROLE_DEMO_STUDENT, ROLE_HR, ROLE_STUDENT} from "entities/constants/constants";
import {Homework} from "../tabs-content/homework/Homework";

SwiperCore.use([Navigation, Pagination]);

export const OnlineTabs = () => {
    const dispatch = useDispatch();
    const roleType = useAppSelector((state) => state.role.roleType);
    const activeTabs = useAppSelector((state) => state.topTabs.activeTabs);
    const swiperRef = useRef<SwiperCore | null>(null);
    const lessonsState = useAppSelector((state) => state.lessons.items);
    const hasHomework = lessonsState.length > 0 ? lessonsState[0].hasHomework : false;

    const tabs = [
        { id: 0, label: 'Детали' },
        { id: 1, label: 'Студенты' },
        { id: 2, label: 'Тесты' },
    ];

    if (hasHomework) {
        tabs.push({ id: 3, label: 'Домашнее задание' });
    }

    let filteredTabs = tabs;

    if (roleType === ROLE_DEMO_STUDENT) {
        filteredTabs = tabs.filter(tab => tab.id === 0);
    } else if (roleType === ROLE_STUDENT) {
        filteredTabs = tabs.filter(tab => tab.id !== 1);
    } else if (roleType === ROLE_HR) {
        filteredTabs = tabs.filter(tab => tab.id !== 2);
    }

    const handleTabClick = (index: number) => {
        // Check if the clicked tab is already active
        if (activeTabs.includes(index)) {
            return;
        }

        const newActiveTabs = [index];
        dispatch(setActiveTabs(newActiveTabs));
        swiperRef.current?.slideTo(newActiveTabs[0]);
    };

    useEffect(() => {
        return () => {
            // Сброс активного таба при размонтировании компонента
            dispatch(setActiveTabs([0]));
        };
    }, [dispatch]);

    useEffect(() => {
        if (swiperRef.current) {
            swiperRef.current.on('slideChange', () => {
                dispatch(setActiveTabs([swiperRef.current?.activeIndex ?? 0]));
            });
        }
    }, [dispatch]);

    return (
        <Swiper
            slidesPerView={'auto'}
            loop={false}
            spaceBetween={0}
            watchOverflow={true}
            className="tabs-nav"
            onSwiper={(swiper) => {
                swiperRef.current = swiper;
            }}
        >
            <div className="swiper-container">
                <div className="swiper-wrapper">
                    {filteredTabs.map((tab) => (
                        <SwiperSlide
                            key={tab.id}
                            className={`swiper-slide ${activeTabs[0] === tab.id ? 'active' : ''}`}
                            onClick={() => handleTabClick(tab.id)}
                        >
                             <span className={`tab-nav-item ${activeTabs[0] === tab.id ? 'active' : ''}`}>
                                 {tab.label}
                             </span>
                        </SwiperSlide>
                    ))}
                </div>
            </div>
            {filteredTabs.map((tab) =>
                activeTabs[0] === tab.id &&
                <div key={tab.id} className={`tab-content ${activeTabs[0] === tab.id ? 'active' : ''}`}/>
            )}
        </Swiper>
    );
};
